import axios from 'axios';
import { Perimetre, Utilisateur } from 'core/models';

export function getUtilisateurs() {
    return axios.get<Utilisateur[]>(`/users`, {
        params: {},
    });
}

export function getUserConnected() {
    return axios.get(`/users/connected`, {
        params: {},
    });
}

export function getPerimetre() {
    return axios.get<Perimetre[]>(`/perimetres`, {
        params: {},
    });
}

export function getUser(id) {
    const config = {
        params: {}, // Any query params you want to add
        displayErrorMsg: false, // Custom config if you handle errors elsewhere
    };

    return axios.get(`/users/${id}`, config);
}

export function postUser(utilisateur: Utilisateur) {
    return axios.post(`/users`, utilisateur);
}

export function createNewAccount(utilisateur: Utilisateur) {
    utilisateur.roles = ['ROLE_NEW_INSCRIPTION'];
    return axios.post(`/users/create_account`, utilisateur);
}

export function putUser(utilisateur: Utilisateur) {
    return axios.put(`/users/` + utilisateur.id, utilisateur);
}

export function deleteUser(utilisateur: Utilisateur) {
    return axios.delete(`/users/` + utilisateur.id, { data: utilisateur });
}

export function isLoginUnique(login: string, id: string) {
    return axios.post(`/users/login_unique`, { login, id });
}

export function isEmailUnique(email: string, id: string) {
    return axios.post(`/users/email_unique`, { email, id });
}

export function exporUtilisateurs(search: object[]) {
    return axios.get<Blob>(`/export_excel/utilisateurs`, {
        params: {
            search: search && search.length ? JSON.stringify(search) : undefined,
        },
        responseType: 'blob',
    });
}

export function resetPassword(username) {
    return axios.post(`/reset_password`, { username: username });
}

export function replaceResponsable({ oldResponsableId, newResponsableId }) {
    return axios.post(`/users/replace_responsable`, { oldResponsableId, newResponsableId });
}

export function refreshToken() {
    return axios.get(`/auth/refresh_token`);
}
